export const resolveCompanionDocumentProfileId = (
  documentProfileId: string | undefined,
  profiles: Array<{ id: string }>
) => {
  if (!documentProfileId) return undefined;

  return profiles.some((profile) => profile.id === documentProfileId)
    ? documentProfileId
    : undefined;
};
